import * as React from "react"
import {
  Alert,
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"
import { useQuery } from "react-query"

const BASE = process.env.REACT_APP_API_BASE_URL || ""

const getUsers = () =>
  fetch(`${BASE}/api/admin/users`, { credentials: "include" }).then(
    async (r) => {
      const body = await r.json().catch(() => null)
      if (!r.ok) throw new Error(body?.error || `status ${r.status}`)
      return body
    }
  )

const fmt = (ts) => (ts ? ts.replace("T", " ").slice(0, 16) : "—")

export default function UsersPanel() {
  const { data, error, isLoading } = useQuery("adminUsers", getUsers, {
    refetchInterval: 60000,
  })

  if (isLoading) return <CircularProgress sx={{ mt: 3 }} />
  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        {String(error.message || error)}
      </Alert>
    )
  }

  const users = data?.users || []
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        {users.length} user{users.length === 1 ? "" : "s"}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>User</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Last login</TableCell>
            <TableCell>First seen</TableCell>
            <TableCell align="right">Clips</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((u) => (
            <TableRow key={u.id} hover>
              <TableCell>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Avatar
                    src={u.avatar_url || undefined}
                    alt={u.display_name || u.email}
                    sx={{ width: 28, height: 28 }}
                  >
                    {(u.display_name || u.email || "?")[0].toUpperCase()}
                  </Avatar>
                  <span>{u.display_name || "—"}</span>
                  {u.is_admin && <Chip size="small" label="admin" color="primary" />}
                </Stack>
              </TableCell>
              <TableCell>{u.email}</TableCell>
              <TableCell>{fmt(u.last_login_at)}</TableCell>
              <TableCell>{fmt(u.created_at)}</TableCell>
              <TableCell align="right">{u.clip_count}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}
